import { isNumber } from 'utils/isNumber';
import { API_BASE_URL } from './configs';

// export interface FoodDetailDataType {
//   food_id: number;
//   name: string;

//   average_peak_glucose_levels: number;
//   average_glucose_change: number;
//   average_time_out_of_target: number;
//   country_code_most_logged: string;
//   meal_timing_most_logged: string;
//   times_logged: number;

//   spike_indicator: string;
//   spike_subtitle: string;

//   percentage_stable_response: number

//   average_score: number;

//   macro_split_data: {
//     id: string;
//     name: string;
//     macro_split: {
//       fat: number;
//       carbs: number;
//       fiber: number;
//       protein: number;
//       calories: number;
//     };
//   }[];
// }

type MacroSplit = {
  fat: number;
  carbs: number;
  fiber: number;
  protein: number;
  calories: number;
};

type MacroSplitData = {
  id: string;
  name: string;
  macro_split: MacroSplit;
};

type MealTimingCounts = {
  lunch: number;
  dinner: number;
  midnight: number;
  afternoon: number;
  breakfast: number;
};

export interface FoodDetailDataType {
  food_id: number;
  name: string;
  average_peak_glucose_levels: number;
  average_glucose_change: number;
  average_time_out_of_target: number;
  country_code_most_logged: string;
  meal_timing_most_logged: string;
  meal_timing_counts: MealTimingCounts;
  average_score: number;
  country_code_to_show_in: string;
  meal_timing_to_show_at: string;
  median_score: number;
  spike_indicator: string;
  spike_subtitle: string;
  percentage_stable_response: number;
  percentage_small_rise: number;
  percentage_medium_spike: number;
  percentage_high_spike: number;
  macro_split_data: MacroSplitData[];
  times_logged: number;
  unique_users_count: number;
  grouped_meals_count: number;
}

export const getFoodDetails = (args: {
  foodId?: string;
  urlFriendlyName?: string;
}): Promise<{ data: FoodDetailDataType; error: any }> => {
  const url = new URL(API_BASE_URL + '/api/v4/glucose_database/details');

  if (Object.hasOwn(args, 'urlFriendlyName') && args.urlFriendlyName) {
    url.searchParams.set('url_friendly_name', args.urlFriendlyName);
  } else if (Object.hasOwn(args, 'foodId') && args.foodId) {
    url.searchParams.set('food_id', args.foodId);
  }

  return fetch(url.href.toString(), {
    method: 'POST',
  })
    .then((res) => res.json())
    .catch((e) => {
      console.log(e);
      return null;
    });
};

// This endpoint calls an LLM on the backend, so (unlike search/details above) it now
// requires either a user token or this shared key (ultrahuman#31946 / ParameterAI #442).
// `getFoodOptimization` is only ever called from `app/(site)/ogdb/[foodId]/page.tsx`, a
// Server Component — this file's code never reaches the browser bundle from that call
// site, so reading a non-`NEXT_PUBLIC_*` env var here is safe, same reasoning as
// `callExpressApi` (lib/commerce/shopify/expressApiHelper.ts). Do NOT call this from a
// 'use client' component without moving it behind an `/api/*` proxy route first, same
// caveat that rail documents for its own key.
export const getFoodOptimization = (args: {
  foodId?: string;
  urlFriendlyName?: string;
}): Promise<any> => {
  const url = new URL(
    API_BASE_URL + '/api/v4/glucose_database/meal_optimisation',
  );
  if (args.urlFriendlyName)
    url.searchParams.append('url_friendly_name', args.urlFriendlyName);
  if (args.foodId) url.searchParams.append('food_id', args.foodId);

  const apiKey = process.env.MEAL_OPTIMISATION_API_KEY;

  return fetch(url.href.toString(), {
    method: 'POST',
    headers: {
      ...(apiKey ? { 'X-Meal-Optimisation-Api-Key': apiKey } : {}),
    },
  })
    .then((res) => res.json())
    .catch((e) => {
      console.log(e);
      return null;
    });
};

export const searchFood = ({
  query,
  count = 10,
  page = 1,
}: {
  query: string;
  count?: number;
  page?: number;
}): Promise<any> => {
  // const data =  Promise.resolve(dumData);
  // return data;

  if (isNumber(query)) {
    return new Promise((resolve) => resolve([]));
  }

  const myHeaders = new Headers();
  // myHeaders.append(
  //   'Authorization',
  //   'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyNjY3MjQ1LCJleHAiOjE3NDc0NTg1NTR9.fWHIC16R94d8LQ-dM1t7b6uQtG62klxxVv0ukjbYCLE',
  // );
  myHeaders.append('TimeZone', 'Asia/Kolkata');
  myHeaders.append('Content-Type', 'application/json');

  const raw = JSON.stringify({
    search_string: query,
    per_page: count,
    page: page,
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
  };

  return fetch(
    'https://api.ultrahuman.com/api/v4/glucose_database/search',
    requestOptions,
  )
    .then((response) => response.json())
    .then((result) => {
      if (result.data && Array.isArray(result.data)) {
        return result.data;
      } else {
        throw new Error('Some error occured while fetching food data');
      }
    })
    .catch((error) => console.error(error));
};
